@import '~style-sheet-helpers/core.less';

.walleted-provider-header-line {
  font-size: 14px;
  line-height: 1.4;
  font-weight: @bold;
  padding: 8px 12px 6px;
}
